module.exports = __webpack_public_path__ + "static/media/ios-skip-forward.148357ac.svg";